"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _webexCore = require("@webex/webex-core");
var _constants = require("../constants");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _request = _interopRequireDefault(require("./request"));
var _turnDiscovery = _interopRequireDefault(require("./turnDiscovery"));
var _metrics = _interopRequireDefault(require("../metrics"));
var _constants2 = _interopRequireDefault(require("../metrics/constants"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } // @ts-ignore
/**
 * Roap options
 * @typedef {Object} RoapOptions
 * @property {String} sdp
 * @property {Meeting} meeting
 * @property {Number} seq
 * @property {Number} tieBreaker
 *  @property {Boolean} reconnect
 */
/**
 * @typedef {Object} SeqOptions
 * @property {String} correlationId
 * @property {String} mediaId
 * @property {Number} seq
 */
/**
 * @class Roap
 * @export
 * @private
 */
var Roap = exports.default = /*#__PURE__*/function (_StatelessWebexPlugin) {
  (0, _inherits2.default)(Roap, _StatelessWebexPlugin);
  var _super = _createSuper(Roap);
  /**
   *
   * @param {Object} attrs
   * @param {Object} options
   */
  function Roap(attrs, options) {
    var _this;
    (0, _classCallCheck2.default)(this, Roap);
    _this = _super.call(this, {}, options);
    /**
     * @instance
     * @type {Object}
     * @private
     * @memberof Roap
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "attrs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastRoapOffer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "options", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "roapHandler", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "roapRequest", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "turnDiscovery", void 0);
    _this.attrs = attrs;
    /**
     * @instance
     * @type {Object}
     * @private
     * @memberof Roap
     */
    _this.options = options;
    /**
     * The Roap Request Server Proxy Object
     * @instance
     * @type {RoapRequest}
     * @private
     * @memberof Roap
     */
    // @ts-ignore
    _this.roapRequest = new _request.default({}, options);
    _this.turnDiscovery = new _turnDiscovery.default(_this.roapRequest);
    return _this;
  }

  /**
   *
   * @param {SeqOptions} options
   * @returns {null}
   * @memberof Roap
   */
  (0, _createClass2.default)(Roap, [{
    key: "sendRoapOK",
    value: function sendRoapOK(options) {
      var _this2 = this;
      return _promise.default.resolve().then(function () {
        // @ts-ignore
        var meeting = _this2.webex.meetings.meetingCollection.getByKey('correlationId', options.correlationId);
        var roapMessage = {
          messageType: _constants.ROAP.ROAP_TYPES.OK,
          version: _constants.ROAP.ROAP_VERSION,
          seq: options.seq
        };
        _loggerProxy.default.logger.log("Roap:index#sendRoapOK --> ROAP OK sending with seq ".concat(options.seq));
        return _this2.roapRequest.sendRoap({
          roapMessage: roapMessage,
          locusSelfUrl: meeting.selfUrl,
          mediaId: options.mediaId,
          isMultistream: meeting.isMultistream,
          locusMediaRequest: meeting.locusMediaRequest
        }).then(function () {
          _loggerProxy.default.logger.log("Roap:index#sendRoapOK --> ROAP OK sent with seq ".concat(options.seq));
        });
      });
    }

    /**
     * Sends a ROAP answer...
     * @param {SeqOptions} options
     * @param {Boolean} options.audioMuted
     * @param {Boolean} options.videoMuted
     * @returns {Promise}
     * @memberof Roap
     */
  }, {
    key: "sendRoapAnswer",
    value: function sendRoapAnswer(options) {
      // @ts-ignore
      var meeting = this.webex.meetings.meetingCollection.getByKey('correlationId', options.correlationId);
      var roapMessage = {
        messageType: _constants.ROAP.ROAP_TYPES.ANSWER,
        sdps: [options.sdp],
        version: _constants.ROAP.ROAP_VERSION,
        seq: options.seq
      };
      return this.roapRequest.sendRoap({
        roapMessage: roapMessage,
        locusSelfUrl: meeting.selfUrl,
        mediaId: options.mediaId,
        isMultistream: meeting.isMultistream,
        locusMediaRequest: meeting.locusMediaRequest
      });
    }

    /**
     * Sends a ROAP error...
     * @param {Object} options
     * @returns {Promise}
     * @memberof Roap
     */
  }, {
    key: "sendRoapError",
    value: function sendRoapError(options) {
      // @ts-ignore
      var meeting = this.webex.meetings.meetingCollection.getByKey('correlationId', options.correlationId);
      var roapMessage = {
        messageType: _constants.ROAP.ROAP_TYPES.ERROR,
        version: _constants.ROAP.ROAP_VERSION,
        errorType: options.errorType,
        seq: options.seq
      };
      return this.roapRequest.sendRoap({
        roapMessage: roapMessage,
        locusSelfUrl: meeting.selfUrl,
        mediaId: options.mediaId,
        isMultistream: meeting.isMultistream,
        locusMediaRequest: meeting.locusMediaRequest
      }).then(function () {
        _loggerProxy.default.logger.log("Roap:index#sendRoapError --> ROAP ERROR sent with seq ".concat(options.seq));
      });
    }

    /**
     * sends a roap media request
     * @param {RoapOptions} options
     * @returns {Promise}
     * @memberof Roap
     */
  }, {
    key: "sendRoapMediaRequest",
    value: function sendRoapMediaRequest(options) {
      var meeting = options.meeting,
        seq = options.seq,
        sdp = options.sdp,
        tieBreaker = options.tieBreaker;
      var roapMessage = {
        messageType: _constants.ROAP.ROAP_TYPES.OFFER,
        sdps: [sdp],
        version: _constants.ROAP.ROAP_VERSION,
        seq: seq,
        tieBreaker: tieBreaker,
        headers: ['includeAnswerInHttpResponse', 'noOkInTransaction']
      };

      // The only time we want to send an empty media id is when we are reconnecting, because this way we tell Locus
      // that it needs to create a new confluence, but when reconnecting we always send TURN_DISCOVERY_REQUEST first,
      // so we don't need to ever send an empty media id here
      var sendEmptyMediaId = false;
      return this.roapRequest.sendRoap({
        roapMessage: roapMessage,
        locusSelfUrl: meeting.selfUrl,
        mediaId: sendEmptyMediaId ? '' : meeting.mediaId,
        isMultistream: meeting.isMultistream,
        preferTranscoding: !meeting.isMultistream,
        locusMediaRequest: meeting.locusMediaRequest
      }).then(function (_ref) {
        var _mediaConnections$;
        var locus = _ref.locus,
          mediaConnections = _ref.mediaConnections;
        if (mediaConnections) {
          meeting.updateMediaConnections(mediaConnections);
        }
        var roapAnswer;
        if (mediaConnections !== null && mediaConnections !== void 0 && (_mediaConnections$ = mediaConnections[0]) !== null && _mediaConnections$ !== void 0 && _mediaConnections$.remoteSdp) {
          var remoteSdp = JSON.parse(mediaConnections[0].remoteSdp);
          if (remoteSdp.roapMessage) {
            var _remoteSdp$roapMessag = remoteSdp.roapMessage,
              answerSeq = _remoteSdp$roapMessag.seq,
              messageType = _remoteSdp$roapMessag.messageType,
              sdps = _remoteSdp$roapMessag.sdps,
              errorType = _remoteSdp$roapMessag.errorType,
              errorCause = _remoteSdp$roapMessag.errorCause,
              headers = _remoteSdp$roapMessag.headers;
            if (messageType === _constants.ROAP.ROAP_TYPES.ANSWER) {
              roapAnswer = {
                seq: answerSeq,
                messageType: messageType,
                sdp: sdps[0],
                errorType: errorType,
                errorCause: errorCause,
                headers: headers
              };
            }
          }
        }
        if (!roapAnswer) {
          _metrics.default.sendBehavioralMetric(_constants2.default.ROAP_HTTP_RESPONSE_MISSING, {
            correlationId: meeting.correlationId,
            messageType: 'ANSWER',
            isMultistream: meeting.isMultistream
          });
        }
        return {
          locus: locus,
          roapAnswer: roapAnswer
        };
      });
    }

    /**
     * Performs a TURN server discovery procedure, which involves exchanging
     * some roap messages with the server. This exchange has to be done before
     * any other roap messages are sent
     *
     * @param {Meeting} meeting
     * @param {Boolean} isReconnecting should be set to true if this is a new
     *                                 media connection just after a reconnection
     * @param {Boolean} [isForced]
     * @returns {Promise}
     */
  }, {
    key: "doTurnDiscovery",
    value: function doTurnDiscovery(meeting, isReconnecting, isForced) {
      return this.turnDiscovery.doTurnDiscovery(meeting, isReconnecting, isForced);
    }
  }, {
    key: "generateTurnDiscoveryRequestMessage",
    value: function generateTurnDiscoveryRequestMessage(meeting, isForced) {
      return this.turnDiscovery.generateTurnDiscoveryRequestMessage(meeting, isForced);
    }
  }, {
    key: "handleTurnDiscoveryHttpResponse",
    value: function handleTurnDiscoveryHttpResponse(meeting, httpResponse) {
      return this.turnDiscovery.handleTurnDiscoveryHttpResponse(meeting, httpResponse);
    }
  }, {
    key: "abortTurnDiscovery",
    value: function abortTurnDiscovery() {
      return this.turnDiscovery.abort();
    }
  }]);
  return Roap;
}(_webexCore.StatelessWebexPlugin);
//# sourceMappingURL=index.js.map
